import React from 'react'
import './intro.css'
import Facebook from '../../assets/facebook.png'
import Instagram from '../../assets/instagram.png'
import Twitter from '../../assets/twitter.png'
import Sushi from '../../assets/sushi.png'
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion'

function Intro() {
  return (
    <motion.div className='intro'
    initial={{opacity: 0}}
    whileInView={{opacity: 1}}
    viewport={{once: true}}
    >
      <div className="i-left">
        <div className="i-name">
          <h1>Hello, I am <span>Goya</span></h1>
          <p>I am the best Japanese restaurant in town</p>
          <br></br>
          <Link to='/menu' className='btn'>
        <button className='button'>Check the menu</button>  
        </Link>   
        </div>
      </div>
      <div className="i-right">
          <img src={Sushi} alt="sushi" />     
      </div>
      <div className="social-media">
        <ul class="social">
            <li><a href="https://facebook.com" target='_blank' rel="noreferrer"><img src={Facebook} alt='Facebook'/></a></li>
            <li><a href="https://instagram.com" target='_blank' rel="noreferrer"><img src={Instagram} alt='Facebook'/></a></li>
            <li><a href="https://twitter" target='_blank' rel="noreferrer"><img src={Twitter} alt='Facebook'/></a></li>
        </ul>
    </div>
    </motion.div>
  )
}

export default Intro